import { formatToDate } from 'brazilian-values'

import { parseDatetime } from '@/utils/format/parseDatetime'
import { getTierLabel } from '@/utils/getTierLabel'

export const getShortCutInformation = ({ expirationDate, isBlocked, lastTransactionPoints, tier, totalPoint }) => {
  return [
    {
      key: 'lastTransaction',
      title: 'Última transação',
      value: lastTransactionPoints,
      hasColor: true
    },
    {
      key: 'nextExpiration',
      title: 'Validade mais próxima',
      value: expirationDate ? formatToDate(new Date(parseDatetime(expirationDate))) : '-',
      hasColor: false
    },
    {
      key: 'currentTier',
      title: 'Tier atual',
      value: getTierLabel(tier),
      hasColor: false
    },
    {
      key: 'totalPoints',
      title: 'Total de pontos',
      value: Number.parseInt(totalPoint || 0),
      hasColor: true,
      isBlocked
    }
  ]
}

export const getColor = (hasColor, value, isBlocked) => {
  if (isBlocked || value < 0) return '$error-standard'
  if (!hasColor) return '$nonInteractivePredominant'

  return '$linkDefault'
}
